<template>
  <div class="arc">
        <el-progress
          type="circle"
          :stroke-width="8"
          :width="90"
          :percentage="value"
          stroke-linecap="butt"
          class="progress1"
        ></el-progress>
        <svg width="100%" height="0">
      <defs>
        <linearGradient id="write" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop
            offset="0%"
            style="stop-color: #25D353"
            stop-opacity="0.8"
          ></stop>
          <stop
            offset="100%"
            style="stop-color: #A7FE1A"
            stop-opacity="1"
          ></stop>
        </linearGradient>
      </defs>
    </svg>
        <!-- <svg width="95" height="95" class="container">
            <circle class="progress"  cx='47' cy ="47" r="40" fill="transparent"  stroke="#18F4BD" stroke-width="10"/>
            <text x="47" y="47" fill="#18F4BD" text-anchor="middle" alignment-baseline="middle">xxx</text>
        </svg> -->
  </div>
</template>
  
<script>
export default {
  props:{
    value: {
      type: [String, Number],
      default: 0,
    },
  },
  components: {
  },
  data() {
    return {
     
    };
  },
  created(){},
  methods:{},
  computed: { },
};
</script>
<style scoped>

/* .progress{
    stroke-dasharray: 251;
    stroke-dashoffset: 0;
} */
.arc{
  width: 96px;
  height: 96px;
}
.progress1 /deep/ .el-progress-circle__track {
  stroke: #0a1a58;
}
.progress1 /deep/ .el-progress__text {
  font-size: 20px !important;
  color: #fff;
}
.progress1 /deep/ .el-progress__text {
  background-image: -webkit-linear-gradient(bottom, #e2ebff, #6da7ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 900;
}
.progress1 /deep/ svg > path:nth-child(2) {
  stroke: url(#write);
}
.progress1 /deep/ .el-progress-circle__track {
  stroke: rgba(251, 221, 151, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/arc_progress_bar.vue